import React, { Component } from 'react';
import { ConfigProvider, Layout, Button, Row, Col, Icon } from 'antd';

import esES from 'antd/es/locale/es_ES';
import * as etiquetas from '../../ApplicationResources';
import { connect } from 'react-redux';
import logoINE from '../../img/logo_INE_blanco-06.png';
import GuiaEstatus from './GuiaEstatus';
import { withRouter } from 'react-router-dom';
import Mensaje from './Mensaje';
import axios from "axios";
import BlockLoader from './Loader.js';
import '../../css/options_menu.css';
import Filtro from '../modulosJDE/Filtros.js';
import { obtenerEstado } from '../../utils/funciones.js';
import { obtenerFormatoDistrito } from '../../utils/funciones.js';
import CFiltrosHeader from './Navbar/CFiltrosHeader';
import Footer from './Elements/Footer';
import HeaderInterno from './Elements/HeaderInterno';

const { Content } = Layout;


let ocultarGrafica = true;

class Template extends Component {
	constructor(props) {
		super(props);

		this.state = {
			cargando : false,
			cargandoMenu : false
		}

		var tipoUsuario = this.props.haySesion ?
			this.props.datosUsuario.tipoUsuario : "";

		if (window.location.pathname === '/menuJDE' && tipoUsuario === 'I') {
			ocultarGrafica = false;
		}
	}

	/**
	* Obtiene los datos para la gráfica que se muestra al inicio
	**/
	cargarGrafica = async (idProcesoElectoral, idDetalleProceso, idEstado, idDistrito) => {
		try {
			if (window.location.pathname === '/menuJDE') {
				this.setState({cargando : true});
	
				var postData = {
					idProcesoElectoral: idProcesoElectoral,
					idDetalleProceso: idDetalleProceso,
					idEstado: idEstado,
					idDistrito: idDistrito
				};
	
				const response = await axios.post(process.env.REACT_APP_API_URL +
					"/ws_reclutaseycae_central/ws/obtenerInformacionGrafica", postData
					, {
						headers: {
							'Accept': 'application/json'
							, 'Content-Type': 'application/json'
							, 'Authorization': localStorage.getItem("jwt-token")  
						}
					}
				);
				this.setState({cargando : false});
	
				return response.data[0];
			}
		}catch(error) {
			this.setState({cargando : false});
		}
	}

	/**
	 * Función que valida el estatus del aspirante para presentar la información correspondiente
	 * @param {*} tipoUsuario E en caso de que sea externo
	 * @returns 
	 */
	validarEstatusAspirante = (tipoUsuario) => {
		if(tipoUsuario === 'E' && this.props.datosAspirante && (window.location.pathname !== '/descargar_acuses' && window.location.pathname !== '/compulsando') &&
			(this.props.datosAspirante.compulsaPositiva === 'A')
		)
			this.props.history.push('/compulsando');
		// Si el usuario aspirante está en estatus declinado y no se encuentra en la pantalla descargar acuses o solicitud declinada, se presenta la pantalla solicitud declinada
		else if (tipoUsuario === 'E' && this.props.datosAspirante && (window.location.pathname !== '/descargar_acuses' && window.location.pathname !== '/solicitud_declinada') && 
			(this.props.datosAspirante.estatusRegistro === 4 || this.props.datosAspirante.estatusRegistro === 5) && (this.props.datosAspirante.compulsaPositiva === 'N')
			)
			this.props.history.push('/solicitud_declinada');
		else if(tipoUsuario === 'E' && this.props.datosAspirante && (window.location.pathname !== '/descargar_acuses' && window.location.pathname !== '/aspiranteCompulsado') &&
			(this.props.datosAspirante.compulsaPositiva === 'S')
		)
			this.props.history.push('/aspiranteCompulsado');
		else
			// Se presenta el contenido normal
			return this.props.contenido
	}

	cargando = (valor) => {
		this.setState({ cargando: valor })
	}

	cargandoMenu = (valor) => {
		this.setState({ cargandoMenu: valor })
	}

	render() {
		const bloquear = this.props.bloqueado || this.props.cargando || this.state.cargando || this.state.cargandoMenu;
		const tipoUsuario = this.props.datosUsuario ?
			this.props.datosUsuario.tipoUsuario : 'E';

		return (
			<ConfigProvider locale={esES}>
				<BlockLoader blocking={bloquear && this.props.bloquearTodo}
					styleClass={'bloq_sobre_todo'}>
					<Layout className="layout template" /* style={{ 'overflowX': 'hidden' }} */>
						<HeaderInterno />
						{this.props.haySesion ?
							<Row>
								<Col xs={24} sm={24} md={24} lg={24}>
									<CFiltrosHeader cargando={this.cargandoMenu} />
								</Col>
							</Row>
							
							: ""}
						
							<Row>
							<Col xs={24} sm={24} md={24} lg={24}>
								<Content className={this.props.contenidoExpandido ? 'contenido_expandido' : undefined}>
							<BlockLoader blocking={bloquear && !this.props.bloquearTodo}>
								{this.props.guia && tipoUsuario === 'E' ? <GuiaEstatus tituloHeaderModule={this.props.tituloHeaderModule} cargando={this.cargando} /> : null}

								{ tipoUsuario === 'E' && this.props.datosAspirante ? (this.props.datosAspirante.estatusRegistro === 4 || this.props.datosAspirante.estatusRegistro === 5 || this.props.datosAspirante.compulsaPositiva === 'S' || this.props.history.location.pathname === '/validaCorreo' ? "" : <Mensaje id='mensajeUsuario' />) 
									: null }
								
								{
									this.props.bloqueado ? <div className='template_cargando'>Cargando...</div> : this.validarEstatusAspirante(tipoUsuario)
								}
							</BlockLoader>

							{window.location.pathname === '/menuJDE' && tipoUsuario === 'I' ? <div>
								<Filtro
									infoGrafica={this.cargarGrafica}
									mostrarBarchart={this.mostrarBarchart}
								>
								</Filtro>
							</div> : ""}
						</Content>
								</Col>
							</Row>
							<Row>
								<Col xs={24} sm={24} md={24} lg={24}>
									<Footer />
								</Col>
							</Row>
					</Layout>
				</BlockLoader>
			</ConfigProvider>
		);
	}
}

Template.defaultProps = {
	guia: true,
	bloqueado: false,
	cargando: false,
	contenidoExpandido: false,
	bloquearTodo: true,
}

const mapStateToProps = (state) => {
	return {
		haySesion: Boolean(state.user.currentUser && state.user.currentUser.username),
		datosUsuario: state.user.currentUser,
		datosAspirante: state.user.datosAspirante
	};
};


export default withRouter(connect(mapStateToProps)(Template));
